import React from 'react';

const InfoBox = ({ type, readings }) => {
  const getStatusClass = (status) => {
    switch (status) {
      case "1": return "text-status-success";
      case "2": return "text-status-warning";
      case "3": return "text-status-error";
      default: return "text-white";
    }
  };

  return (
    <div className="flex flex-col px-2 py-1.5 text-xs rounded bg-slate-700 min-w-[170px] max-w-[240px]">
      <div className="flex gap-3 justify-between text-white">
        <div className="shrink-0">Type:</div>
        <div className="text-right truncate">{type}</div>
      </div>
      {readings.map((reading, index) => (
        <div key={index} className="flex gap-3 justify-between mt-1.5">
          <div className="text-white shrink-0">{reading.key}:</div>
          <div className={`text-right truncate ${getStatusClass(reading.status)}`} title={reading.value}>
            {reading.value}
          </div>
        </div>
      ))}
    </div>
  );
};

export default InfoBox;